/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ArmyDto } from './armyDto';
import { CivilizationDto } from './civilizationDto';
import { CultureEventDto } from './cultureEventDto';
import { GovernmentDto } from './governmentDto';
import { GreatPersonMarkerDto } from './greatPersonMarkerDto';
import { HutDto } from './hutDto';
import { PyramidDto } from './pyramidDto';
import { ResourceDto } from './resourceDto';
import { ScoutDto } from './scoutDto';
import { TechnologyDto } from './technologyDto';
import { UnitDto } from './unitDto';
import { VillageDto } from './villageDto';

export interface CivilizationBoardDto { 
    civilizationName?: string;
    civilization?: CivilizationDto;
    pyramid?: PyramidDto;
    trade?: number;
    government?: GovernmentDto;
    culture?: number;
    coins?: number;
    scouts?: Array<ScoutDto>;
    armies?: Array<ArmyDto>;
    governments?: Array<GovernmentDto>;
    technologies?: Array<TechnologyDto>;
    resources?: Array<ResourceDto>;
    greatPersonMarkers?: Array<GreatPersonMarkerDto>;
    unitTypeRanks?: { [key: string]: number; };
    combatBonuses?: number;
    stackingLimit?: number;
    battleHandSize?: number;
    cultureHandSize?: number;
    maximumCities?: number;
    travelSpeed?: number;
    passability?: CivilizationBoardDto.PassabilityEnum;
    allCoins?: number;
    allSpendableCoins?: number;
    discoveredBuildings?: Array<string>;
    visible?: boolean;
    unitsCount?: number;
    villagesCount?: number;
    hutsCount?: number;
    cultureEvents?: Array<CultureEventDto>;
    units?: Array<UnitDto>;
    villages?: Array<VillageDto>;
    huts?: Array<HutDto>;
}
export namespace CivilizationBoardDto {
    export type PassabilityEnum = 'ExceptWater' | 'CrossWater' | 'HoldWater' | 'CrossAny';
    export const PassabilityEnum = {
        ExceptWater: 'ExceptWater' as PassabilityEnum,
        CrossWater: 'CrossWater' as PassabilityEnum,
        HoldWater: 'HoldWater' as PassabilityEnum,
        CrossAny: 'CrossAny' as PassabilityEnum
    };
}